import { createSelector } from 'reselect'

const getFavouriteIds = (state: any) =>
  (state.entities && state.entities.favourites && state.entities.favourites.allIds) || []

export default createSelector(getFavouriteIds, (ids) => (id: any) => ids.includes(parseInt(id, 10)))
